import { useInput } from 'react-admin';    
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';

const JsonInput = props => {
    const {
        input: {
            onChange,
            value,
        }
    } = useInput(props);

    const { disabled } = props;

    const handleChange = d => {
        if (!d?.jsObject) {
            return;
        }
        onChange(d?.jsObject)
    }

    return (
        <JSONInput
            onChange={handleChange}
            placeholder={value}
            viewOnly={disabled}
            id={props?.source}
            locale={ locale }
            height='550px'
        />
    );
};
export default JsonInput;
